"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var translates = l.Translator.translate;
var adupExpTranslationKeys = [
    'None',
    'System Not Supported',
    'No TVSU',
    'Error Launch TVSU',
    'Error Download TVSU',
    'Unhandled Exception',
    'Wrong Request',
    'Not Lenovo',
    'Low Version',
    'Waiting',
    'system update failed to upgrade',
    'Error Install TVSU',
    'Communication Failed',
    'User Cancelled'
];
var adupExpTranslations = l.Translator.translateGroup(adupExpTranslationKeys);
var ExceptionPopupModel = /** @class */ (function () {
    function ExceptionPopupModel() {
        this.visible = false;
        this.showTVSUDownloadFinishPopup = true;
        this.exception = LSBV4.Component.ADUPExceptionEnum.None;
        this.specialException = '';
    }
    return ExceptionPopupModel;
}());
exports.ExceptionPopupModel = ExceptionPopupModel;
var ExceptionPopup = /** @class */ (function (_super) {
    __extends(ExceptionPopup, _super);
    function ExceptionPopup(props) {
        return _super.call(this, props) || this;
    }
    ExceptionPopup.prototype.render = function () {
        var model = this.props;
        var exceptionText = model.specialException !== '' ? translates(model.specialException) : adupExpTranslations[adupExpTranslationKeys[model.exception]];
        if (model.exception == 2) { //2:no tvsu
            var _here_link = "https://pcsupport.lenovo.com/in/en/solutions/ht003029";
            var _tran_notvsu = translates("click x for more on tvsu|Click &here to learn more about system update (TVSU).", "&here");
            var _tran_here = translates('softwareupgrade introcontent4|here');
            var _tip_notvsu = React.createElement("span", null,
                exceptionText,
                React.createElement("br", null),
                React.createElement("span", { style: { display: "flex" } },
                    _tran_notvsu.split("&here")[0],
                    "\u00A0",
                    React.createElement("a", { href: _here_link, target: "_blank" }, _tran_here),
                    "\u00A0",
                    _tran_notvsu.split("&here")[1]));
            exceptionText = _tip_notvsu;
        }
        if (model.visible === true) {
            return React.createElement("div", null,
                React.createElement("div", { className: "dow-adup-exception-result dow-adup-result-dialog-box" },
                    React.createElement("div", { className: "dow-adup-exception-result-inline-Block dow-adup-fullWidth" },
                        React.createElement("div", { className: "dow-adup-exception-result-padding-20" },
                            React.createElement("div", { className: "dow-adup-exception-result-inline-Block dow-adup-fullWidth" },
                                React.createElement("div", { className: "dow-adup-desktop-msg" },
                                    React.createElement("div", null,
                                        React.createElement("span", { className: "dow-adup-desktop-icon icon-adup" }),
                                        React.createElement("span", { className: "dow-adup-h3" }, translates('System Update'))),
                                    React.createElement("div", { className: "dow-adup-exception-result-machine-info" },
                                        React.createElement("p", null, exceptionText),
                                        model.exception === LSBV4.Component.ADUPExceptionEnum.ErrorDownloadTVSU ?
                                            React.createElement("a", { href: LSBV4.Component.ADUPV1.TVSU_DOWNLOAD_URL, target: "_blank", onClick: model.closeExceptionHandler }, translates('download tvsu manually'))
                                            : null),
                                    React.createElement("div", { className: "dow-adup-exception-result-buttons" },
                                        model.exception === LSBV4.Component.ADUPExceptionEnum.NoTVSU ?
                                            React.createElement("a", { className: "dow-adup-button dow-adup-blue-solid dow-adup-exception-result-InstallButton", onClick: model.downloadTVSUHandler }, translates('Install'))
                                            : null,
                                        model.exception === LSBV4.Component.ADUPExceptionEnum.NoTVSU ?
                                            React.createElement("a", { className: "dow-adup-button dow-adup-blue-solid", onClick: model.cancelDownloadTVSUHandler }, translates('Cancel'))
                                            :
                                                React.createElement("a", { className: "dow-adup-button dow-adup-blue-solid", onClick: model.specialException === 'Installing Reboot Required' ? model.rebootCloseHandler : model.closeExceptionHandler }, translates('OK')))))))),
                React.createElement("div", { className: "dow-adup-load" }));
        }
        else {
            return null;
        }
    };
    return ExceptionPopup;
}(React.Component));
exports.ExceptionPopup = ExceptionPopup;
var AdupExceptionModel = /** @class */ (function () {
    function AdupExceptionModel() {
        this.visible = false;
        this.exception = LSBV4.Component.ADUPExceptionEnum.None;
        this.specialException = '';
    }
    return AdupExceptionModel;
}());
exports.AdupExceptionModel = AdupExceptionModel;
var AdupException = /** @class */ (function (_super) {
    __extends(AdupException, _super);
    function AdupException(props) {
        return _super.call(this, props) || this;
    }
    AdupException.prototype.render = function () {
        var model = this.props;
        var exceptionText = model.specialException ?
            model.specialException.startsWith('External***') ?
                model.specialException.replace('External***', '')
                : translates(model.specialException)
            : adupExpTranslations[adupExpTranslationKeys[model.exception]];
        return this.props.visible == true ? React.createElement("div", { className: "dow-adup-exception-content dow-adup-head-content" },
            React.createElement("p", null, exceptionText)) : null;
    };
    return AdupException;
}(React.Component));
exports.AdupException = AdupException;
